module.exports = __webpack_public_path__ + "static/illustration-main-e9279bb62c9809fb1adc0d55e9a48b7d.svg";